import { BarGraphDirection } from '../model';
import { ReadableElement } from './base/readable-element';
import { calculatePercent } from './shared/math-utils';
import { VariableUtil } from '../utils/variable-util';
export class BarGraphElement extends ReadableElement {
    constructor(element, permissionChecker, variableCommunicator, variableStore, localization) {
        super(element, permissionChecker, variableCommunicator, variableStore, localization);
        this.defaultBarColor = '#6fd149';
        this.defaultUpperLimitColor = '#ff4448';
        this.defaultLowerLimitColor = '#0f60e8';
        this.barText = '';
        this.$barRect = this.$element.find('rect');
        this.$barText = this.$element.find('text[id="text"]').last();
        if (this.model.version && this.model.version >= 1) {
            const backgroundColor = this.model.backgroundColor ? this.model.backgroundColor : 'transparent';
            this.barElement = this.$element.children(`path[fill='${backgroundColor}']`);
            this.defaultTransform = this.barElement.attr('transform');
            this.$barRect.attr('transform', this.defaultTransform);
        }
        setTimeout(() => {
            this.initFrameNode();
        }, 0);
    }
    get readVariableName() {
        if (!this.model) {
            throw new Error('Model cannot be null');
        }
        if (null == this.model.version || this.model.version < 2) {
            return this.model.variableName;
        }
        else {
            const variable = this.model.readVariable;
            if (!variable) {
                return undefined;
            }
            return VariableUtil.getConvertedVariableName(this.variableStore, variable);
        }
    }
    initFrameNode() {
        const arcPath = Snap(this.$element[0]);
        const b = arcPath.getBBox(true);
        this.rootElement.append('rect').attr('id', 'StateFrame').attr('width', b.width).attr('height', b.height).attr('fill', 'transparent');
    }
    updateVariableValue(value) {
        const variableValue = Number(value).valueOf();
        const maxValue = Number(this.model.max).valueOf();
        const minValue = Number(this.model.min).valueOf();
        const useAlarmLimit = this.model.useAlarmLimit;
        const useAlarmUpperLimit = null != this.model.upperLimit;
        const useAlarmLowerLimit = null != this.model.lowerLimit;
        let barColor = this.model.barColor;
        const upperLimitColor = this.model.upperLimitColor;
        const lowerLimitColor = this.model.lowerLimitColor;
        const percentageFont = this.model.percentageFont;
        let box;
        if (this.model.version && this.model.version >= 1) {
            box = this.barElement[0].getBBox();
        }
        else {
            box = this.$barRect.parent()[0].getBBox();
        }
        const percent = calculatePercent(minValue, maxValue, variableValue);
        let translateY = 0;
        if (this.model.direction === BarGraphDirection.DownToUp || this.model.direction === BarGraphDirection.LeftToRight) {
            translateY = box.height * (1 - percent);
        }
        if (!barColor) {
            barColor = this.defaultBarColor;
        }
        if (useAlarmLimit) {
            if (useAlarmUpperLimit && variableValue > +this.model.upperLimit) {
                if (upperLimitColor) {
                    barColor = upperLimitColor;
                }
                else {
                    barColor = this.defaultUpperLimitColor;
                }
            }
            else if (useAlarmLowerLimit && variableValue < +this.model.lowerLimit) {
                if (lowerLimitColor) {
                    barColor = lowerLimitColor;
                }
                else {
                    barColor = this.defaultLowerLimitColor;
                }
            }
        }
        this.$barRect.attr('height', box.height * percent);
        this.$barRect.attr('width', box.width);
        this.$barRect.attr('fill', barColor);
        if (this.model.version && this.model.version >= 1) {
            this.$barRect.attr('transform', this.defaultTransform + ` translate(0,${translateY})`);
        }
        else {
            this.$barRect.attr('transform', `translate(0,${translateY})`);
        }
        this.barText = (percent * 100).toFixed(0) + '%';
        this.$barText.text(this.barText);
        if (percentageFont) {
            this.$barText.attr('font-family', 'Microsoft YaHei');
            this.$barText.attr('font-size', percentageFont.fontSize + '');
            this.$barText.attr('fill', percentageFont.color);
            if (percentageFont.isBold) {
                this.$barText.attr('font-weight', 'bold');
            }
            if (percentageFont.isItalic) {
                this.$barText.attr('font-style', 'italic');
            }
            if (percentageFont.isUnderline) {
                this.$barText.attr('text-decoration', 'underline');
            }
        }
    }
}
